import gql from 'graphql-tag';

const GET_PLAN_BANNERS = gql`
  query planBanners {
    plan_banners {
      is_enabled
      banners {
        image_url
        image_url_sp
        payment_url
        alt_text
        target
        display_order
        is_discounted
      }
    }
  }
`;

export { GET_PLAN_BANNERS };
